import React from 'react';
import Chart from 'react-apexcharts';

function DashboardPieChartLeft({
  total = 0,
  allowedPercentage = 0,
  blockedPercentage = 0,
  loading = true,
}) {
  const options = {
    colors:
      loading || (allowedPercentage === 0 && blockedPercentage === 0)
        ? ['#bbbbbb']
        : ['#141738', '#3F7CDB'],
    tooltip: {fillSeriesColor: false},
    dataLabels: {enabled: false},
    labels: ['Resolved', 'Unresolved'],
    legend: false,
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '91%',
          background: 'transparent',
          labels: {
            show: false,
          },
        },
        startAngle: 0,
        endAngle: 360,
        expandOnClick: false,
        customScale: 0.98,
        offsetY: 0,
        stroke: {
          width: 3,
          colors: ['#FFFFFF'],
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    chart: {
      width: 250,
      height: 250,
      sparkline: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
  };

  const series =
    allowedPercentage === 0 && blockedPercentage === 0
      ? [1]
      : [allowedPercentage, blockedPercentage];

  return (
    <div
      style={{maxWidth: '100%', width: '234px'}}
      className="relative flex justify-center items-center"
    >
      <Chart
        options={options}
        series={series}
        type="donut"
        height={264}
        width="100%"
      />
      <div
        className={`absolute flex flex-col items-center w-fit`}
        style={{right: 'auto', top: 'auto'}}
      >
        <span className="text-tiny text-[#858DAA] font-medium text-center">
          Total no. of <br /> Cases
        </span>
        <h1
          className={`font-semibold m-0 p-0 text-deepBlue ${
            total?.toString()?.length > 5 ? 'text-[20px]' : 'text-[36px]'
          }`}
        >
          {loading ? 0 : Number(total)?.toLocaleString()}
        </h1>
      </div>
    </div>
  );
}

function DashboardPieChartRight({
  flagged = 0,
  flaggedPercentage = 0,
  nonFlaggedPercentage = 0,
  loading = true,
}) {
  const options = {
    colors:
      loading || (flaggedPercentage === 0 && nonFlaggedPercentage === 0)
        ? ['#bbbbbb']
        : ['#A13E3F', '#F3787A'],
    dataLabels: {enabled: false},
    labels: ['Allowed', 'Blocked'],
    legend: false,
    stroke: {
      width: 0,
    },
    tooltip: {
      fillSeriesColor: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '91%',
          background: 'transparent',
          labels: {
            show: false,
          },
        },
        startAngle: 0,
        endAngle: 360,
        expandOnClick: false,
        customScale: 0.98,
        offsetY: 0,
        stroke: {
          width: 3,
          colors: ['#FFFFFF'],
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    chart: {
      width: 250,
      height: 250,
      sparkline: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
  };

  const series =
    flaggedPercentage === 0 && nonFlaggedPercentage === 0
      ? [1]
      : [flaggedPercentage, nonFlaggedPercentage];

  return (
    <div
      style={{maxWidth: '100%', width: '234px'}}
      className="relative flex justify-center items-center"
    >
      <Chart
        options={options}
        series={series}
        type="donut"
        height={264}
        width="100%"
      />
      <div
        className="absolute flex flex-col items-center w-fit"
        style={{right: 'auto', top: 'auto'}}
      >
        <span className="text-tiny text-[#858DAA] font-medium text-center">
          Total no. of <br /> Resolved Cases
        </span>
        <h1
          className={`font-semibold m-0 p-0 text-deepBlue ${
            flagged?.toString()?.length > 5 ? 'text-[20px]' : 'text-[36px]'
          }`}
        >
          {loading ? 0 : flagged.toLocaleString()}
        </h1>
      </div>
    </div>
  );
}

export {DashboardPieChartLeft, DashboardPieChartRight};
